import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';

export function fetchMe() {
    return asyncActionCreator(types.CURRENT_USER_UPDATED, serverApi.getMe(), (json, status, headers) => {
        return {
            currentUser: json,
            serverVersion: headers.get('X-Server-Version')
        };
    });
};



// WEBPACK FOOTER //
// ./src/js/actions/userActionCreators.js